var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "field_head",
      class: { "cursor-pointer": this.can_sort },
      on: { click: _vm.setListOrdering },
    },
    [
      !_vm.is_html
        ? _c("span", [_vm._v("\n\t\t\t" + _vm._s(this.field_name) + "\n\t\t")])
        : _c("span", { domProps: { innerHTML: _vm._s(_vm.field_name) } }),
      _vm._v(" "),
      _vm.is_current_field_sort
        ? _c("div", { staticClass: "badge badge-info" }, [
            _c("i", {
              staticClass: "fal opacity-100 color-white",
              class: _vm.current_sort_class,
            }),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }